import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Table, Space, Tooltip, Button, PageHeader, Tag, Input } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import { handleApiSuccess, handleApiError, MyBreadcrumb, confirmDelete } from "utils";
import {
  billingItemListService,
  billingItemDeleteService,
} from "services/billing";

const { Search } = Input;

export default function ItemIndex() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [dataSource, setDataSource] = useState([]);

  const columns = [
    { title: "Name", dataIndex: "product_name", key: "product_name" },
    {
      title: "Category",
      key: "category",
      render: (t, r) => (r.category && r.category.name) || "-",
    },
    {
      title: "Type",
      dataIndex: "product_type",
      key: "product_type",
      render: (t) =>
        t === "SERVICE" ? <Tag color="blue">Service</Tag> : <Tag color="gold">Physical Good</Tag>,
    },
    { title: "Unit", dataIndex: "unit", key: "unit" },
    {
      title: "Regular Price",
      dataIndex: "regular_price",
      key: "regular_price",
      render: (t) => (t || t === 0 ? "$" + Number(t).toFixed(2) : ""),
    },
    {
      title: "Taxable",
      dataIndex: "is_taxable",
      key: "is_taxable",
      render: (t) =>
        t === false ? <Tag>No Tax</Tag> : <Tag color="green">Taxable</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title="Edit">
            <Button
              onClick={() => history.push("/billing/items/update/" + record._id)}
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              onClick={() => deleteRecord(record._id)}
              shape="circle"
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setIsLoading(true);
    billingItemListService()
      .then((response) => {
        setIsLoading(false);
        const items = response.data.items || [];
        setAllData(items);
        setDataSource(items);
      })
      .catch((error) => {
        setIsLoading(false);
        handleApiError(error);
      });
  };

  const deleteRecord = (id) => {
    confirmDelete().then(() => {
      setIsLoading(true);
      billingItemDeleteService(id)
        .then((response) => {
          handleApiSuccess(response);
          loadData();
        })
        .catch((error) => {
          setIsLoading(false);
          handleApiError(error);
        });
    });
  };

  const onSearch = (value) => {
    const v = (value || "").toLowerCase();
    setDataSource(
      allData.filter(
        (i) =>
          (i.product_name || "").toLowerCase().includes(v) ||
          (i.sku || "").toLowerCase().includes(v) ||
          ((i.category && i.category.name) || "").toLowerCase().includes(v) ||
          (i.unit || "").toLowerCase().includes(v)
      )
    );
  };

  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Items", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <ShoppingOutlined /> }}
        title="Items for Sale (Parts / Services)"
        subTitle={
          <Search
            allowClear
            placeholder="Filter items"
            onChange={(e) => onSearch(e.target.value)}
            style={{ width: 220 }}
          />
        }
        extra={[
          <Button
            key="create"
            shape="round"
            onClick={() => history.push("/billing/items/create")}
            type="primary"
            icon={<PlusCircleOutlined />}
          >
            Add Item
          </Button>,
        ]}
      />
      <Table dataSource={dataSource} columns={columns} loading={isLoading} rowKey="_id" />
    </div>
  );
}
